import { toast } from 'sonner'
import { UserPickerDialog } from '@/components/user-select'
import { useAddUsersToDepartment } from '@/hooks/useDepartments'
import { showError } from '@/lib/error'
import type { UserListItem } from '@/api/users'

interface AddUserDialogProps {
	open: boolean
	onOpenChange: (open: boolean) => void
	departmentId: number
	departmentName: string
	onSuccess?: () => void
}

export function AddUserDialog({
	open,
	onOpenChange,
	departmentId,
	departmentName,
	onSuccess,
}: AddUserDialogProps) {
	const addMutation = useAddUsersToDepartment()

	const handleConfirm = async (users: UserListItem[]) => {
		try {
			await addMutation.mutateAsync({
				departmentId,
				userIds: users.map((user) => user.id),
			})
			toast.success('添加用户成功')
			onOpenChange(false)
			onSuccess?.()
		} catch (error) {
			console.error('添加用户失败:', error)
			showError(error, '添加用户失败')
		}
	}

	return (
		<UserPickerDialog
			open={open}
			onOpenChange={onOpenChange}
			multiple
			title={`添加成员到「${departmentName}」`}
			confirmText="添加"
			onConfirm={handleConfirm}
			isSubmitting={addMutation.isPending}
		/>
	)
}
